import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { withStyles } from '@material-ui/core'

import Markdown from 'components/ui/Markdown'
import Loading from 'components/ui/Loading'

import { getTerm } from 'api/terms'

class Terms extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      terms: ''
    }
  }

  componentDidMount() {
    this.fetchTerms()
  }

  fetchTerms = async () => {
    const domain = `${window.location.protocol}//${window.location.host}`
    try {
      const params = {
        l: navigator.language,
        domain: domain
      }

      const { data } = await getTerm(params)

      this.setState({ terms: data.term.description })
    } catch (error) {
      console.log(error)
    }

    this.setState({ loading: false })
  }

  render() {
    const { classes } = this.props
    const { loading, terms } = this.state

    return (
      <div className={classes.Terms_wrapper}>
        <div className={classes.Terms_container}>
          {
            loading
            ? <Loading />
            : <Markdown markdown={terms} />
          }          
        </div>
      </div>
    )
  }
}

const styles = () => ({
  Terms_wrapper: {
    maxHeight: '100vh',
    margin: '50px 30px'
  },
  Terms_container: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 100px)',
    marginTop: 16
  }
})

export default withTranslation()(withStyles(styles)(Terms))
